<div class="container-fluid m-0 p-0" *ngIf="!showLoader">


    <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
        <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
            <h6 class="font-bold m-0">{{ "LECTURE_SCHEDULE" | translate | titlecase }}</h6>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12">
            <form [formGroup]="searchForm" (change)="searchFormChange()" (submit)="searchFormSubmit()">
                <div class="row bg-white border m-0 py-3">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase }}</label>
                                <select class="form-control" formControlName="year" (change)="getYearSemesters()">
                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of years" [ngValue]="field.id">
                                    {{
                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                    }}
                                </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                <select class="form-control" formControlName="semester" (change)="getBatches()">
                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of semesters" [ngValue]="field.id">
                                    {{
                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                    field?.semesterNameEn
                                    }}
                                </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                <select class="form-control" formControlName="batch">
                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of batches" [ngValue]="field.id">
                                    {{
                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                    }}
                                </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4 form-check text-center">
                                <input formControlName="active" class="form-check-input" type="checkbox" id="activeFlag">
                                <label class="form-check-label" for="activeFlag">{{ "Active" | translate | titlecase }}</label>
                                
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="searchForm.controls.active.touched && searchForm.controls.active.invalid && searchForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-end">
                            <div class="col-3">
                                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                                    {{ "RESET" | translate | titlecase }}</button>
                                <button type="submit" class="btn btn-primary m-2 rounded-0"><i class="fas fa"></i>
                                    {{ "SEARCH" | translate | titlecase }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row" *ngIf="searched">
                <div class="col-12 d-flex flex-wrap justify-content-between">
                    <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
                    <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                        routerLink="/schedule/schedule-create"
                        [queryParams]="{yearId: yearId,semesterId:semesterId,gradeId:gradeId}"><i class="fas fa-plus"></i> {{ "ADD" | translate |
                        titlecase }}</button>
                </div>
        
                <div class="col-12">
        
                    <div class="bg-white border pt-3 my-4">
                        <h5 class="font-16 font-black px-3">{{ "SCHEDULE_SETUP" | translate | titlecase }}</h5>
        
                        <app-loader [show]="showLoader"></app-loader>
        
                        <div class="table-responsive py-3" *ngIf="!showLoader">
                            <div style="height: 500px; overflow-y: scroll;">
                                <table  *ngIf="schedules.length >= 1" class="table-striped" data-sticky-header="true"
                                    id="datatable">
                                    <thead style="position: sticky; top: 0; background: white;">
                                        <tr>
                                            <th rowspan="2">{{ "ID" | translate | titlecase }}</th>
                                            <th rowspan="2">{{ "EFFECTIVE_DATE_FROM" | translate | titlecase }}</th>
                                            <th rowspan="2">{{ "EFFECTIVE_DATE_TO" | translate | titlecase }}</th>
                                            <th rowspan="2">{{ "STATUS" | translate | titlecase }}</th>
                                            <th rowspan="2">{{ "ACTIVE" | translate | titlecase }}</th>
                                            <!-- <th class="border-0 font-14 px-2 text-grey" rowspan="2">{{ "UNLOCK" | translate | titlecase
                                                                    }}</th>
                                                                    <th class="border-0 font-14 px-2 text-grey" rowspan="2">{{ "LOCK" | translate | titlecase
                                                                    }}</th> -->
                                            <th class="border-0 font-14 px-2 text-grey" rowspan="2">{{ "DETAILS" | translate | titlecase
                                                }}</th>
                                            <th class="border-0 font-14 px-2 text-grey" rowspan="2">{{ "MODIFY" | translate | titlecase
                                                }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let res of schedules">
                                            <td>{{res?.id}}</td>
                                            <td>{{res?.effectiveDateFrom| date}}</td>
                                            <td>{{res?.effectiveDateTo| date}}</td>
                                            <td>{{res?.scheduleStatus}}</td>
                                            <td>{{(res?.active == 'YES')? ('YES' | translate | titlecase) : ('NO' | translate |
                                                titlecase) }}</td>
                                            <!-- <td class="text-bold text-warning">
                                                                            <a class="btn btn-sm btn-link text-warning" routerLink="/schedule/schedule-setup-update"
                                                                                [queryParams]="{scheduleId: res?.id}"><i class="fas fa-unlock"></i>
                                                                                {{ "UNLOCK" | translate | titlecase }}</a>
                                                                    </td>
                                                                    <td class="text-bold text-warning">
                                                                            <a class="btn btn-sm btn-link text-warning" routerLink="/schedule/schedule-setup-update"
                                                                                [queryParams]="{scheduleId: res?.id}"><i class="fas fa-lock"></i>
                                                                                {{ "LOCK" | translate | titlecase }}</a>
                                                                    </td>    -->
                                            <td class="text-bold text-warning">
                                                <a class="btn btn-sm btn-link text-warning" routerLink="/schedule/schedule-details"
                                                    [queryParams]="{scheduleId: res?.id, yearid: yearId, semesterid: semesterId, gradeid: gradeId}"><i
                                                        class="fas fa-search"></i>
                                                    {{ "DETAILS" | translate | titlecase }}</a>
                                            </td>
                                            <td class="text-bold text-warning">
                                                <a class="btn btn-sm btn-link text-warning" routerLink="/schedule/schedule-update"
                                                    [queryParams]="{scheduleId: res?.id,yearId: yearId,semesterId:semesterId,gradeId:gradeId}"><i
                                                        class="fas fa-edit"></i>
                                                    {{ "MODIFY" | translate | titlecase }}</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<app-loader [attr.show]="showLoader"></app-loader>